<div
  [ngStyle]="{ background: 'url(assets/images/MADB-BANNER-6.jpg)' }"
  class="content-header"
>
  <span class="header-title">Jumpers</span>
</div>
<div class="form">
  <div class="section-container" *ngFor="let section of sections">
    <div class="title">
      <span>{{ section.title }}</span>
    </div>
    <span class="base"> Base: {{ userInfo.baseName }} ({{ userInfo.baseCode }})</span>
    <div class="content" style="margin-top: 20px">
      <div
        class="datum"
        [ngClass]="'width-' + datum.width"
        *ngFor="let datum of section.data"
      >
        <div class="input-container">
          <span *ngIf="datum.input" class="input-label"
            >{{ datum.placeholder }}
            <span *ngIf="datum.required" class="required-asterisk">*</span>
            <span *ngIf="!datum.required" class="required-asterisk"
              ><br
            /></span>
          </span>
          <!-- numeric input-->
          <input
            *ngIf="datum.input && datum.key === 'weight'"
            [attr.aria-label]="datum.placeholder"
            type="number"
            [name]="datum.key"
            [placeholder]="datum.placeholder"
            [(ngModel)]="jumper[datum.key]"
          />
          <!-- text input -->
          <input
            [attr.aria-label]="datum.placeholder"
            type="text"
            [name]="datum.key"
            *ngIf="datum.input && datum.type !== 'date' && datum.key !=='weight'"
            [placeholder]="datum.placeholder"
            [(ngModel)]="jumper[datum.key]"
          />
          <!-- checkbox -->
          <div class="checkbox-container" *ngIf="datum.checkbox">
            <input
              [attr.aria-label]="datum.label"
              type="checkbox"
              [(ngModel)]="jumper[datum.key]"
            />
            <span class="input-label">{{ datum.label }}</span>
          </div>
          <!-- datepicker -->
          <input
            aria-label="Date Picker"
            type="date"
            [name]="datum.key"
            *ngIf="datum.type === 'date'"
            [(ngModel)]="jumper[datum.key]"
          />
          <!-- dropdown -->
          <app-dropdown
            [(choice)]="datum.choice"
            *ngIf="datum.dropdown"
            [label]="datum.label"
            [options]="datum.options"
            key="name"
            (selectedDropdownItem)="onSelectedDropdownItem($event, datum)"
          ></app-dropdown>
        </div>
      </div>
    </div>
  </div>
  <!-- add qualifications section -->
  <p class="qualifications-text">
    The qualifications list shows "typical" qualifications utilized by
    smokejumpers. If a qualification is not listed that you need, click on the
    Add Qualification button at the bottom of the page to add the qualification.
  </p>
  <div class="section-container split" style="border-bottom: none">
    <div class="left-section">
      <div class="title">
        <span>Qualifications</span>
      </div>
      <input
        aria-label="Search / Filter"
        (keyup)="filterQuals($event)"
        class="quals-query"
        placeholder="Search/Filter"
        [(ngModel)]="qualsQuery"
      />
      <div class="quals-container">
        <div
          class="qualification datum"
          *ngFor="let qualification of qualifications; index as i"
        >
          <input
            aria-label="Select Qualification"
            type="checkbox"
            [(ngModel)]="qualification.checked"
            [name]="qualification.name"
          />
          <label class="label" [for]="qualification.name">{{
            qualification.name
          }}</label>
        </div>
      </div>
    </div>
    <div class="right-section">
      <div class="title">
        <span>Trainee Qualifications</span>
      </div>
      <input
        aria-label="Search / Filter"
        (keyup)="filterTQuals($event)"
        class="quals-query"
        placeholder="Search/Filter"
        [(ngModel)]="tqualsQuery"
      />
      <div class="quals-container">
        <div
          class="qualification datum"
          *ngFor="let qualification of traineeQualifications; index as i"
        >
          <input
            aria-label="Select Trainee Qualification"
            type="checkbox"
            [name]="qualification.name"
            [(ngModel)]="qualification.checked"
          />
          <label class="label" [for]="qualification.qualName">{{
            qualification.name
          }}</label>
        </div>
      </div>
    </div>
  </div>
  <div class="section-container submit-button-container">
    <app-button
      [text]="mode"
      (clicked)="submitForm($event)"
      class="new-incident-button"
    ></app-button>
    <app-button
      style="margin-left: 20px"
      text="Cancel"
      cancel="true"
      (clicked)="cancel()"
      class="cancel-button"
    ></app-button>
  </div>
</div>
